import { render } from "./EventDashboard.vue?vue&type=template&id=98c06112&scoped=true"
import script from "./EventDashboard.vue?vue&type=script&lang=js"
export * from "./EventDashboard.vue?vue&type=script&lang=js"

import "./EventDashboard.vue?vue&type=style&index=0&id=98c06112&lang=scss"
import "./EventDashboard.vue?vue&type=style&index=1&id=98c06112&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c06112"]])

export default __exports__